<template>
  <div class="navbar">
    <div class="navbar__inner">
      <span class="navbar__logo">S</span>
      <span class="navbar__brand">Sartor</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "Navbar"
}
</script>

<style scoped>
.navbar {
  background: #fff;
  border-bottom: 1px solid #ece7de;
}
.navbar__inner {
  max-width: 900px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 24px;
}
.navbar__logo {
  width: 30px;
  height: 30px;
  border-radius: 8px;
  background: #b52118;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 800;
  font-size: 16px;
}
.navbar__brand {
  font-size: 16px;
  font-weight: 700;
  color: #1a1814;
  letter-spacing: -0.01em;
}
</style>
